import React, { useState, useEffect, useCallback, useRef } from "react";
import NewOrderModal from "./NewOrderModal";
import GeneratePDF from "./GeneratePDF";
import Pagination from "./Pagination";
// import DrawingModal from "./DrawingModal";
import EditOrderModal from "./EditOrderModal";
import useOrdersData from "../hooks/useOrdersData";
import useAdminData from "../hooks/useAdminData";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useTheme } from "../context/ThemeContext";
// import DeleteOrderModal from "./DeleteOrderModal";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ConfirmStatusModal from "./ConfirmStatusModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import { getUserRole } from "../utils/Auth";
import Tooltip from "@mui/material/Tooltip";
import OrderItemsModal from "./OrderItemsModal";
import API_BASE_URL from "../config";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import AdvancePaymentsModal from "./AdvancePaymentsModal";

const OrdersList = () => {
  // ✅ Customers marad
  const {
    orders,
    fetchOrders,
    deleteOrder,
    updateOrder,
    // openDrawingModal,
    // handleSaveDrawing,
    // handleClearDrawing,
    uploadInvoice,
    downloadInvoice,
    deleteInvoice,
    toggleFinalizatStatus,
    uploadDrawing,
    downloadDrawing,
    deleteDrawing,
    setOrders
  } = useOrdersData();
  const { customers, fetchCustomers, myCustomers, fetchMyCustomers } =
    useAdminData();

  const [searchTerm, setSearchTerm] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isDrawingModalOpen, setIsDrawingModalOpen] = useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  // const [drawingData, setDrawingData] = useState("");
  // const [successMessage, setSuccessMessage] = useState("");
  // const signatureRef = useRef(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [orderToEdit, setOrderToEdit] = useState(null);
  const [pdfKey, setPdfKey] = useState(Date.now()); // 🔥 PDF frissítéséhez
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [uploadSuccessType, setUploadSuccessType] = useState("success"); // ✅ Alapértelmezett sikeres üzenet
  const fileInputRefs = useRef({});
  const ordersPerPage = 12;
  const storedPage = localStorage.getItem("currentPage");
  const [isDeleteInvoiceModalOpen, setIsDeleteInvoiceModalOpen] =
    useState(false);
  const [orderToDeleteInvoice, setOrderToDeleteInvoice] = useState(null);
  const [orderToDeleteDrawing, setOrderToDeleteDrawing] = useState(null);
  const [isDeleteDrawingModalOpen, setIsDeleteDrawingModalOpen] =
    useState(false);
  const { darkMode, toggleTheme } = useTheme(); // 🔥 toggleTheme-et is importáljuk!
  const [isDeleteOrderModalOpen, setIsDeleteOrderModalOpen] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [confirmStatusModalOpen, setConfirmStatusModalOpen] = useState(false);
  const [orderToToggle, setOrderToToggle] = useState(null);
  const userRole = getUserRole();
  const [selectedOrderForItems, setSelectedOrderForItems] = useState(null);
  const [isItemsModalOpen, setIsItemsModalOpen] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [selectedOrderForAvans, setSelectedOrderForAvans] = useState(null);
  const [isAvansModalOpen, setIsAvansModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    storedPage ? parseInt(storedPage, 10) : 1
  );

  const DEFAULT_YEAR = 2026;
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(DEFAULT_YEAR);
  const [selectedCompany, setSelectedCompany] = useState("All");

  const checkPassword = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/auth/verify-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Parolă incorectă!");
      }

      if (data.message?.toLowerCase().includes("corect")) {
        // ✅ 1. Kapcsoljuk be a statokat
        setShowStats(true);
        setIsPasswordModalOpen(false);
        setPasswordError(null);

        // ✅ 2. Frissítsük az adatokat, hogy a cost/profit értékek betöltődjenek
        await fetchOrders();
      } else {
        setPasswordError(data.message || "Parolă incorectă!");
      }
    } catch (error) {
      setPasswordError(error.message);
    }
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };

  const filteredOrders = orders.filter((order) => {
    const customer = myCustomers.find((c) => c.id === order.customerId);
    const searchText = searchTerm.toLowerCase();

    return (
      order.orderNumber.toString().includes(searchText) ||
      (customer?.name?.toLowerCase().includes(searchText) ?? false) ||
      (customer?.phone?.toLowerCase().includes(searchText) ?? false) ||
      (customer?.city?.toLowerCase().includes(searchText) ?? false) ||
      (customer?.county?.toLowerCase().includes(searchText) ?? false) ||
      (order.invoiceFileName?.toLowerCase().includes(searchText) ?? false) ||
      (order.invoiceUrl?.toLowerCase().includes(searchText) ?? false)
    );
  });

  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const customerA = myCustomers.find((c) => c.id === a.customerId);
    const customerB = myCustomers.find((c) => c.id === b.customerId);

    let valA, valB;

    if (sortConfig.key === "customerName") {
      valA = customerA?.name?.toLowerCase() || "";
      valB = customerB?.name?.toLowerCase() || "";
    } else if (
      sortConfig.key === "totalPrice" ||
      sortConfig.key === "orderNumber"
    ) {
      valA = Number(a[sortConfig.key]) || 0;
      valB = Number(b[sortConfig.key]) || 0;
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    } else {
      valA = a[sortConfig.key]?.toString().toLowerCase() || "";
      valB = b[sortConfig.key]?.toString().toLowerCase() || "";
    }

    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // Oldalakra bontás a szűrt adatokkal
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const formatPrice = (price) => {
    if (!price) return "0";
    return price.toLocaleString("ro-Ro");
  };

  useEffect(() => {
    if (myCustomers.length === 0) {
      fetchMyCustomers(); // 🔥 Ha még nem töltöttük be, akkor lekérjük az admin saját ügyfeleit
    }
  }, [myCustomers.length, fetchMyCustomers]);

  // csak egyszerű resetre figyel
  useEffect(() => {
    if (!isPasswordModalOpen) {
      setSearchTerm("");
      const searchInput = document.querySelector('input[placeholder="Căutare..."]');
      if (searchInput) {
        searchInput.value = "";
        searchInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  }, [isPasswordModalOpen]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    fetchOrders(selectedYear, selectedCompany);
  }, [fetchOrders, selectedYear, selectedCompany]);

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);
  }, [currentPage]);

  const handleEditOrder = (order) => {
    setOrderToEdit(order);
    setIsEditModalOpen(true);
  };

  // const handleOpenDrawing = async (order) => {
  //   setSelectedOrder(order); // ✅ Most már helyes
  //   const drawingData = await openDrawingModal(order);
  //   setDrawingData(drawingData);
  //   setIsDrawingModalOpen(true);
  // };

  // const handleSaveDrawingLocal = async () => {
  //   if (!selectedOrder) return;

  //   const success = await handleSaveDrawing(selectedOrder, signatureRef);

  //   if (success) {
  //     setSuccessMessage("✅ A rajz sikeresen mentve lett!");
  //     setTimeout(() => setSuccessMessage(""), 3000);
  //     setIsDrawingModalOpen(false);
  //     setPdfKey(Date.now()); // 🔥 Újra rendereli a GeneratePDF-et!
  //   }
  // };

  // const handleClearDrawingLocal = async () => {
  //   if (!selectedOrder) return;

  //   const success = await handleClearDrawing(selectedOrder, signatureRef);

  //   if (success) {
  //     setSuccessMessage("✅ A rajz sikeresen törölve lett!");
  //     setTimeout(() => setSuccessMessage(""), 3000);
  //     setDrawingData("N/A");
  //     setPdfKey(Date.now()); // 🔥 Újra rendereli a GeneratePDF-et!
  //   }
  // };

  const handleFileUpload = async (orderId, file) => {
    if (!file) return;

    if (file.type !== "application/pdf") {
      setUploadSuccess("❌ Doar fișiere PDF sunt acceptate!");
      setUploadSuccessType("error"); // 🔥 Beállítjuk pirosra
      setTimeout(() => setUploadSuccess(null), 2000);
      return;
    }

    try {
      await uploadInvoice(orderId, file);
      setUploadSuccess("✅ Factura a fost încărcată!");
      setUploadSuccessType("success"); // 🔥 Beállítjuk zöldre
      fetchOrders();
    } catch (error) {
      console.error("❌ Eroare la încărcarea facturii:", error);
      setUploadSuccess("❌ Eroare la încărcare!");
      setUploadSuccessType("error"); // 🔥 Piros üzenet sikertelen feltöltésnél
    } finally {
      setTimeout(() => setUploadSuccess(null), 2000);
    }
  };

  const handleDeleteInvoice = async () => {
    if (!orderToDeleteInvoice) return;

    try {
      await deleteInvoice(orderToDeleteInvoice.id);
      fetchOrders(); // 🔄 Frissítés törlés után
      setDeleteSuccess("✅ Factura a fost ștearsă cu succes!"); // ✅ Popup megjelenítés

      setTimeout(() => setDeleteSuccess(null), 2000);
    } catch (error) {
      console.error("❌ Eroare la ștergerea facturii:", error);
    } finally {
      setIsDeleteInvoiceModalOpen(false);
      setOrderToDeleteInvoice(null);
    }
  };

  const handleDrawingUpload = async (orderId, file) => {
    if (!file) return;

    if (file.type !== "application/pdf") {
      setUploadSuccess("❌ Doar fișiere PDF sunt acceptate!");
      setUploadSuccessType("error");
      setTimeout(() => setUploadSuccess(null), 2000);
      return;
    }

    try {
      await uploadDrawing(orderId, file); // Ezt a useOrdersData hook-ba tedd be
      setUploadSuccess("✅ Schița a fost încărcată!");
      setUploadSuccessType("success");
      fetchOrders();
    } catch (err) {
      console.error("Eroare la încărcarea schiței:", err);
      setUploadSuccess("❌ Eroare la încărcare!");
      setUploadSuccessType("error");
    } finally {
      setTimeout(() => setUploadSuccess(null), 2000);
    }
  };

  const handleDeleteDrawing = async () => {
    if (!orderToDeleteDrawing) return;

    try {
      await deleteDrawing(orderToDeleteDrawing.id); // 👉 ez a hookban van definiálva
      setDeleteSuccess("✅ Schița a fost ștearsă cu succes!");
      fetchOrders(); // 🔁 frissítés törlés után

      setTimeout(() => setDeleteSuccess(null), 2000);
    } catch (err) {
      console.error("❌ Eroare la ștergerea schiței:", err);
    } finally {
      setOrderToDeleteDrawing(null);
      setIsDeleteDrawingModalOpen(false);
    }
  };

  return (
    <div
      className={`min-h-screen p-2 py-6 ${darkMode ? "bg-gray-900" : "bg-gray-200"
        }`}
    >
      {/* ✅ Sikeres feltöltés popup */}
      {uploadSuccess && (
        <div
          className={`fixed top-10 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-opacity duration-500
      ${uploadSuccessType === "success"
              ? "bg-green-600 text-white"
              : "bg-red-600 text-white"
            }
    `}
        >
          {uploadSuccess}
        </div>
      )}

      {/* ✅ Sikeres törlés popup */}
      {deleteSuccess && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-opacity duration-500">
          {deleteSuccess}
        </div>
      )}

      <div className="flex justify-between items-center mb-4">
        <h2
          className={`text-2xl font-semibold ${darkMode ? "text-white" : "text-black"
            }`}
        >
          Comenzile mele
        </h2>

        {/* 🔥 Flex container a kereső és a gomb számára */}
        <div className="relative flex items-center gap-8">
          <SearchIcon
            className={`absolute left-3 transition-all ${darkMode ? "text-gray-300" : "text-gray-500"
              }`}
          />
          <input
            type="text"
            placeholder="Căutare..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={`pl-10 pr-4 py-2 border rounded-3xl shadow-sm w-96 transition-all ${darkMode
              ? "bg-gray-800 text-white border-gray-600 placeholder-gray-400"
              : "bg-white text-gray-900 border-gray-300 placeholder-gray-500"
              }`}
          />

          <select
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            className={`px-4 py-2 rounded-3xl border transition ${darkMode
              ? "bg-gray-800 text-white border-gray-600"
              : "bg-white text-black border-gray-300"
              }`}
          >
            <option value="All">Toate firmele</option>
            <option value="Marmorex">Marmorex</option>
            <option value="GranitOnline">Granit Online</option>
          </select>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className={`px-4 py-2 rounded-3xl border transition ${darkMode
              ? "bg-gray-800 text-white border-gray-600"
              : "bg-white text-black border-gray-300"
              }`}
          >
            {[currentYear, currentYear - 1].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

          {userRole === "Admin" && (
            <button
              onClick={() => setIsPasswordModalOpen(true)}
              className="px-4 py-2 rounded-3xl border-2 transition font-bold"
              style={{
                borderColor: darkMode ? "#66bb6a" : "#2e7d32",
                color: darkMode ? "#66bb6a" : "#fff",
                backgroundColor: darkMode ? "transparent" : "#2e7d32",
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = darkMode ? "#81c784" : "#1b5e20";
                e.target.style.backgroundColor = darkMode
                  ? "rgba(102, 187, 106, 0.1)"
                  : "rgba(46, 125, 50, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = darkMode ? "#66bb6a" : "#2e7d32";
                e.target.style.backgroundColor = darkMode
                  ? "transparent"
                  : "#2e7d32";
              }}
            >
              🔐 Statistici
            </button>
          )}

          <button
            onClick={() => setIsModalOpen(true)}
            className="px-4 py-2 rounded-3xl transition border-2"
            style={{
              borderColor: darkMode ? "#90caf9" : "#0056B3",
              color: darkMode ? "#90caf9" : "#ffffff",
              backgroundColor: darkMode ? "transparent" : "#0056B3",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = darkMode ? "#90caf9" : "#003B80";
              e.target.style.backgroundColor = darkMode
                ? "rgba(144, 202, 249, 0.1)"
                : "rgba(0, 86, 179, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = darkMode ? "#90caf9" : "#0056B3";
              e.target.style.backgroundColor = darkMode
                ? "transparent"
                : "#0056B3";
            }}
          >
            + Adaugă comandă
          </button>

        </div>
      </div>

      <div className="flex flex-col justify-between min-h-[650px]">
        <div className="overflow-x-auto flex-grow text-sm leading-tight">
          <table
            className={`w-full border ${darkMode
              ? "border-gray-700 bg-gray-900 text-gray-300"
              : "border-gray-400 bg-white text-gray-800 shadow-lg"
              }`}
          >
            {" "}
            <thead>
              <tr
                className={`${darkMode
                  ? "bg-gray-700 text-white"
                  : "bg-gray-300 text-gray-900"
                  }`}
              >
                {" "}
                <th
                  className="border text-sm p-2 min-w-[120px] max-w-[120px] text-center cursor-pointer"
                  onClick={() => handleSort("orderNumber")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Nr. Comanda</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "orderNumber" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "orderNumber" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "orderNumber" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-s ${sortConfig.key === "orderNumber" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  className="border text-sm p-2 min-w-[100px] max-w-[100px] text-center cursor-pointer"
                  onClick={() => handleSort("customerName")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Client</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "customerName" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "customerName" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "customerName" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "customerName" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                <th className="border p-2 text-s min-w-[100px] max-w-[100px]">Nr. Telefon</th>
                <th
                  className="border p-2 cursor-pointer min-w-[90px]"
                  onClick={() => handleSort("totalPrice")}
                >
                  <div className="flex items-center justify-center text-s gap-1">
                    <span>Suma</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "totalPrice" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "totalPrice" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "totalPrice" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "totalPrice" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                {showStats && (
                  <>
                    <th className="border p-2 text-s w-[90px]">Cost achiziție</th>
                    <th className="border p-2 text-s w-[100px]">Profit net</th>
                    <th className="border p-2 text-s w-[90px]">% Marjă</th>
                  </>
                )}

                <th className="border p-2 text-s w-[100px]">Avans (%)</th>

                {/* <th className="border p-2">Oraș</th> */}
                {/* <th className="border p-2">Județ</th> */}
                <th className="border p-2 text-s min-w-[100px]">Dată</th>
                <th className="border p-2 text-s w-[110px]">Sursă</th>
                <th className="border text-sm p-2 min-w-[212px] max-w-[212px] text-center">Factură</th>
                <th className="border p-2 text-s w-[140px]">PDF</th>
                <th className="border p-2 text-s w-[180px]">Schiță</th>
                <th className="border p-2 text-s w-[90px]">
                  Status
                </th>
                <th className="border p-2 text-s w-[200px]">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order, index) => {
                  const customer = myCustomers.find(
                    (c) => c.id === order.customerId
                  );
                  return (
                    <tr
                      key={order.id}
                      className={`border transition text-center ${darkMode
                        ? index % 2 === 0
                          ? "bg-gray-800 hover:bg-gray-700"
                          : "bg-gray-900 hover:bg-gray-700"
                        : index % 2 === 0
                          ? "bg-gray-100 hover:bg-gray-200"
                          : "bg-white hover:bg-gray-200"
                        }`}
                    >
                      <td
                        className={`border p-2 min-w-[120px] max-w-[120px] text-center font-semibold cursor-pointer hover:underline ${darkMode
                          ? "text-white hover:text-gray-300"
                          : "text-black hover:text-gray-700"
                          }`}
                        onClick={() => {
                          setSelectedOrderForItems(order);
                          setIsItemsModalOpen(true);
                        }}
                      >
                        {order.orderNumber}
                      </td>
                      <td className="border min-w-[160px] max-w-[160px] truncate px-4 py-2">
                        <Tooltip title={customer?.name || "N/A"} arrow>
                          <span>{customer?.name || "N/A"}</span>
                        </Tooltip>
                      </td>
                      <td className="border p-2 min-w-[100px] max-w-[100px] truncate text-center">
                        <Tooltip title={customer?.phone || "N/A"} arrow>
                          <span className="block text-ellipsis whitespace-nowrap overflow-hidden">
                            {customer?.phone || "N/A"}
                          </span>
                        </Tooltip>
                      </td>
                      <td className="border p-2 w-[100px]">
                        {formatPrice(order.totalPrice)} €
                      </td>
                      {showStats && (
                        <>
                          <td className={`border p-2 w-[90px] text-center ${order.totalCost > order.totalPrice ? "text-red-500 font-bold" : ""}`}>
                            {formatPrice(order.totalCost)} €
                          </td>
                          <td className={`border p-2 w-[120px] text-center ${order.grossProfit >= 0 ? "text-green-500 font-semibold" : "text-red-500 font-semibold"}`}>
                            {formatPrice(order.grossProfit)} €
                          </td>
                          <td className={`border p-2 w-[90px] text-center ${order.profitMargin >= 20 ? "text-green-500 font-semibold" : order.profitMargin > 0 ? "text-yellow-500 font-semibold" : "text-red-500 font-semibold"}`}>
                            {order.profitMargin.toFixed(2)}%
                          </td>
                        </>
                      )}
                      <td
                        className="border text-sm p-2 w-[100px] text-center"
                      >
                        {order.isAdvanceOrder ? (
                          <div
                            className="flex flex-col items-center cursor-pointer hover:opacity-80"
                            title="Vizualizează plățile de avans"
                            onClick={() => {
                              setSelectedOrderForAvans(order);
                              setIsAvansModalOpen(true);
                            }}
                          >
                            <span
                              className={`text-xs font-semibold ${darkMode ? "text-gray-100" : "text-gray-800"
                                }`}
                            >
                              {order.advanceCompletionPercent
                                ? `${Math.round(order.advanceCompletionPercent)}%`
                                : "0%"}
                            </span>

                            <div
                              className={`w-16 rounded-full h-2 mt-1 ${darkMode ? "bg-gray-500" : "bg-gray-300"
                                }`}
                            >
                              <div
                                className={`h-2 rounded-full transition-all duration-300 ${darkMode ? "bg-green-500" : "bg-green-500"
                                  }`}
                                style={{
                                  width: `${Math.min(order.advanceCompletionPercent || 0, 100)}%`,
                                }}
                              ></div>
                            </div>

                          </div>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>


                      {" "}
                      {/* <td className="border p-2">
                      {customer ? customer.city : "N/A"}
                    </td> */}
                      {/* <td className="border p-2">
                      {customer ? customer.county : "N/A"}
                    </td> */}
                      <td className="border p-2 min-w-[100px] max-w-[100px] text-center">
                        {new Date(order.createdAt).toLocaleDateString("ro-RO")}
                      </td>

                      <td className="border p-2 w-[110px] text-center">
                        {(() => {
                          const src = order.customerSource ?? 0;
                          const colors = [
                            "bg-gray-100 text-gray-600",
                            "bg-blue-100 text-blue-800",
                            "bg-purple-100 text-purple-800",
                            "bg-green-100 text-green-800"
                          ];
                          const labels = ["Neclasificat", "Online", "Recomandare", "Recurent"];
                          return (
                            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${colors[src] || colors[0]}`}>
                              {labels[src] || "Online"}
                            </span>
                          );
                        })()}
                      </td>

                      {/* ✅ Külön oszlop a letöltés/törlés/feltöltéshez */}
                      <td className="border text-sm p-2 text-center min-w-[212px] max-w-[212px]">
                        {order.invoiceUrl ? (
                          <div className="flex items-center gap-2 justify-center">
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<DownloadIcon />}
                              sx={(theme) => ({
                                borderColor: darkMode ? "#66bb6a" : "#36993a",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: darkMode ? "#66bb6a" : "#36993a",
                                "&:hover": {
                                  borderColor: darkMode ? "#66bb6a" : "#2d7d32",
                                  backgroundColor: darkMode
                                    ? "rgba(102, 187, 106, 0.1)"
                                    : "rgba(54, 153, 58, 0.1)",
                                },
                              })}
                              onClick={() => downloadInvoice(order.invoiceUrl)}
                            >
                              Descarcă
                            </Button>

                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<DeleteIcon />}
                              sx={{
                                borderColor: "#f44336",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: "#f44336",
                                "&:hover": {
                                  borderColor: "#f44336",
                                  backgroundColor: "rgba(244, 67, 54, 0.1)",
                                },
                              }}
                              onClick={() => {
                                setOrderToDeleteInvoice(order);
                                setIsDeleteInvoiceModalOpen(true);
                              }}
                            >
                              Ștergere
                            </Button>
                          </div>
                        ) : (
                          <div className="relative flex items-center justify-center">
                            <input
                              type="file"
                              ref={(el) =>
                                (fileInputRefs.current[order.id] = el)
                              }
                              accept="application/pdf"
                              className="hidden"
                              onChange={(e) => {
                                if (e.target.files.length > 0) {
                                  handleFileUpload(order.id, e.target.files[0]);
                                }
                              }}
                            />
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<UploadFileIcon />}
                              sx={(theme) => ({
                                borderColor: darkMode ? "#90caf9" : "#0056B3",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: darkMode ? "#90caf9" : "#0056B3",
                                "&:hover": {
                                  borderColor: darkMode ? "#90caf9" : "#003B80",
                                  backgroundColor: darkMode
                                    ? "rgba(144, 202, 249, 0.1)"
                                    : "rgba(0, 86, 179, 0.15)",
                                },
                              })}
                              onClick={() =>
                                fileInputRefs.current[order.id]?.click()
                              }
                            >
                              Încarcă
                            </Button>
                          </div>
                        )}
                      </td>
                      <td className="border p-2 w-[140px]">
                        <GeneratePDF
                          key={pdfKey}
                          orderData={order}
                          customerData={customer}
                        />
                      </td>
                      {/* <td className="border p-2">
                      <Button
                        variant="outlined"
                        startIcon={<VisibilityIcon />}
                        sx={(theme) => ({
                          borderColor: darkMode ? "#90caf9" : "#0056B3",
                          color: darkMode ? "#90caf9" : "#0056B3",
                          "&:hover": {
                            borderColor: darkMode ? "#90caf9" : "#003B80",
                            backgroundColor: darkMode
                              ? "rgba(144, 202, 249, 0.1)"
                              : "rgba(0, 86, 179, 0.15)",
                          },
                        })}
                        onClick={() => handleOpenDrawing(order)}
                      >
                        Vizualizare
                      </Button>
                    </td> */}
                      <td className="border text-sm p-2 text-center w-[140px]">
                        {order.drawingUrl ? (
                          <div className="flex items-center gap-2 justify-center">
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<DownloadIcon />}
                              sx={{
                                borderColor: darkMode ? "#66bb6a" : "#36993a",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: darkMode ? "#66bb6a" : "#36993a",
                                "&:hover": {
                                  borderColor: darkMode ? "#66bb6a" : "#2d7d32",
                                  backgroundColor: darkMode
                                    ? "rgba(102, 187, 106, 0.1)"
                                    : "rgba(54, 153, 58, 0.1)",
                                },
                              }}
                              onClick={() => downloadDrawing(order.drawingUrl)} // Ezt implementálnod kell!
                            >
                              Descarcă
                            </Button>

                            <Button
                              variant="outlined"
                              startIcon={<DeleteIcon />}
                              size="small"
                              sx={{
                                borderColor: "#f44336",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: "#f44336",
                                "&:hover": {
                                  borderColor: "#f44336",
                                  backgroundColor: "rgba(244, 67, 54, 0.1)",
                                },
                              }}
                              onClick={() => {
                                setOrderToDeleteDrawing(order); // új state kell: `orderToDeleteDrawing`
                                setIsDeleteDrawingModalOpen(true); // új state: `isDeleteDrawingModalOpen`
                              }}
                            >
                              Ștergere
                            </Button>
                          </div>
                        ) : (
                          <div className="relative flex items-center justify-center">
                            <input
                              type="file"
                              ref={(el) =>
                              (fileInputRefs.current[`drawing-${order.id}`] =
                                el)
                              }
                              accept="application/pdf"
                              className="hidden"
                              onChange={(e) => {
                                if (e.target.files.length > 0) {
                                  handleDrawingUpload(
                                    order.id,
                                    e.target.files[0]
                                  );
                                }
                              }}
                            />
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<UploadFileIcon />}
                              sx={{
                                borderColor: darkMode ? "#90caf9" : "#0056B3",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                                color: darkMode ? "#90caf9" : "#0056B3",
                                "&:hover": {
                                  borderColor: darkMode ? "#90caf9" : "#003B80",
                                  backgroundColor: darkMode
                                    ? "rgba(144, 202, 249, 0.1)"
                                    : "rgba(0, 86, 179, 0.15)",
                                },
                              }}
                              onClick={() =>
                                fileInputRefs.current[
                                  `drawing-${order.id}`
                                ]?.click()
                              }
                            >
                              Încarcă
                            </Button>
                          </div>
                        )}
                      </td>
                      <td className="border p-2 w-[90px]">
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{
                            borderColor: order.finalizat
                              ? "#66bb6a"
                              : "#ffa726",
                            color: order.finalizat ? "#66bb6a" : "#ffa726",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            padding: "2px 8px",
                            minWidth: "fit-content",
                            fontWeight: "bold",
                            minWidth: "80px", // 👈 Fix szélesség beállítása
                            maxWidth: "80px", // 👈 Fix szélesség beállítása
                            justifyContent: "center",
                            "&:hover": {
                              borderColor: order.finalizat
                                ? "#66bb6a"
                                : "#fb8c00",
                              backgroundColor: order.finalizat
                                ? "rgba(102, 187, 106, 0.1)"
                                : "rgba(255, 167, 38, 0.1)",
                            },
                          }}
                          onClick={() => {
                            setOrderToToggle(order);
                            setConfirmStatusModalOpen(true);
                          }}
                        >
                          {order.finalizat ? "Finalizat" : "Neexecutat"}
                        </Button>
                      </td>
                      <td className="border p-2 w-[140px]">
                        <div className="flex justify-center gap-2">
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            sx={{
                              maxWidth: "110px",
                              borderColor: darkMode ? "#90caf9" : "#0056B3",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              color: darkMode ? "#90caf9" : "#0056B3",
                              "&:hover": {
                                borderColor: darkMode ? "#90caf9" : "#003B80",
                                backgroundColor: darkMode
                                  ? "rgba(144, 202, 249, 0.1)"
                                  : "rgba(0, 86, 179, 0.15)",
                              },
                            }}
                            onClick={() => handleEditOrder(order)}
                          >
                            Editare
                          </Button>

                          {userRole === "Admin" && (
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<DeleteIcon />}
                              sx={{
                                maxWidth: "110px",
                                fontSize: "0.75rem",
                                textTransform: "none",
                                padding: "2px 8px",
                                minWidth: "fit-content",
                              }}
                              color="error"
                              onClick={() => {
                                setOrderToDelete(order);
                                setIsDeleteOrderModalOpen(true);
                              }}
                            >
                              Ștergere
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center p-4 text-gray-400">
                    Nu există comenzi.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

      <NewOrderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fetchOrders={fetchOrders}
        selectedYear={selectedYear}
        customers={myCustomers || []}
      />

      <OrderItemsModal
        open={isItemsModalOpen}
        onClose={() => setIsItemsModalOpen(false)}
        order={selectedOrderForItems}
      />

      <AdvancePaymentsModal
        order={selectedOrderForAvans}
        open={isAvansModalOpen}
        onClose={() => setIsAvansModalOpen(false)}
        onAdvanceUpdated={(newPercent) => {
          setOrders((prev) =>
            prev.map((o) =>
              o.id === selectedOrderForAvans.id
                ? { ...o, advanceCompletionPercent: newPercent }
                : o
            )
          );
        }}
      />

      {/* <DrawingModal
        selectedOrder={selectedOrder}
        drawingData={drawingData}
        signatureRef={signatureRef}
        handleSaveDrawing={handleSaveDrawingLocal}
        handleClearDrawing={handleClearDrawingLocal}
        isModalOpen={isDrawingModalOpen}
        closeModal={() => setIsDrawingModalOpen(false)}
      /> */}

      <EditOrderModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        order={orderToEdit}
        updateOrder={(order) => updateOrder(order, false, selectedYear, selectedCompany)} // ✅ Ensure `false` is passed
      />

      <ConfirmDeleteModal
        isOpen={isDeleteInvoiceModalOpen}
        onClose={() => setIsDeleteInvoiceModalOpen(false)}
        onConfirm={handleDeleteInvoice}
        entityName="factură"
        title="Sigur doriți să ștergeți factura?"
        message={`Factura asociată comenzii ${orderToDeleteInvoice?.orderNumber} va fi ștearsă definitiv.`}
      />

      <ConfirmDeleteModal
        isOpen={isDeleteDrawingModalOpen}
        onClose={() => setIsDeleteDrawingModalOpen(false)}
        onConfirm={handleDeleteDrawing}
        entityName="schiță"
        title="Sigur doriți să ștergeți schița?"
        message={`Schița asociată comenzii ${orderToDeleteDrawing?.orderNumber} va fi ștearsă definitiv.`}
      />

      <ConfirmDeleteModal
        isOpen={isDeleteOrderModalOpen}
        onClose={() => setIsDeleteOrderModalOpen(false)}
        onConfirm={async () => {
          if (orderToDelete) {
            await deleteOrder(orderToDelete.id, false, selectedYear); // admin nézetben vagyunk
            setDeleteSuccess("✅ Comanda a fost ștearsă cu succes!");
            setTimeout(() => setDeleteSuccess(null), 2000);
            setIsDeleteOrderModalOpen(false);
          }
        }}
        entityName="comandă"
        title="Sigur doriți să ștergeți această comandă?"
        message={`Comanda cu numărul ${orderToDelete?.orderNumber} va fi ștearsă definitiv.`}
      />

      {/* <DeleteOrderModal
        isOpen={isDeleteOrderModalOpen}
        onClose={() => setIsDeleteOrderModalOpen(false)}
        onConfirm={() => {
          if (orderToDelete) {
            deleteOrder(orderToDelete.id); // 🔥 Most már csak akkor hívja meg, ha van rendelés!
            setIsDeleteOrderModalOpen(false);
          }
        }}
        order={orderToDelete}
      /> */}
      <ConfirmStatusModal
        open={confirmStatusModalOpen}
        onClose={() => {
          setOrderToToggle(null);
          setConfirmStatusModalOpen(false);
        }}
        onConfirm={async () => {
          if (orderToToggle) {
            await toggleFinalizatStatus(orderToToggle.id, null, selectedYear);
          }
          setConfirmStatusModalOpen(false);
          setOrderToToggle(null);
        }}
        isFinalizat={orderToToggle?.finalizat}
      />

      <Dialog
        open={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: "16px", width: 400 },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Introduceți parola pentru a vizualiza statisticile
        </DialogTitle>
        <DialogContent sx={{ padding: 3 }}>
          <TextField
            type="password"
            label="Parola"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!passwordError}
            helperText={passwordError || ""}
            sx={{ mt: 2, borderRadius: "8px" }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
          <Button
            onClick={() => setIsPasswordModalOpen(false)}
            color="secondary"
            sx={{ borderRadius: "20px", paddingX: 3 }}
          >
            Anulare
          </Button>
          <Button
            onClick={checkPassword}
            variant="contained"
            color="primary"
            sx={{ borderRadius: "20px", paddingX: 3 }}
          >
            Verificare
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default OrdersList;
